import React from 'react';
import { useTranslation } from 'react-i18next';

import { LanguageCode } from '@Reducers/metadata';

interface LanguageSwitchProps {
  className?: string;
}

const LanguageSwitch: React.FC<LanguageSwitchProps> = ({ className = '' }) => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === LanguageCode.English ? LanguageCode.Hindi : LanguageCode.English);
  };

  const currentLanguage = i18n.language;
  const isEnglish = currentLanguage === LanguageCode.English;

  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center gap-2 px-3 py-2 rounded-md border border-gray-300 hover:border-gray-400 transition-colors ${className}`}
      title={`Switch to ${isEnglish ? 'Hindi' : 'English'}`}>
      <span className='text-sm font-medium'>{isEnglish ? 'हिंदी' : 'English'}</span>
      <svg className='w-4 h-4' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129'
        />
      </svg>
    </button>
  );
};

export default LanguageSwitch;
